import { render, staticRenderFns } from "./TableVisit.vue?vue&type=template&id=64a8b329"
import script from "./TableVisit.vue?vue&type=script&lang=js"
export * from "./TableVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports